import GDriveWrapper from './gdrive-wrapper'

export default GDriveWrapper
